import { MainTableFilterModulesEnum } from 'src/app/core/enums/main-table-filter-modules.enum';
import { Privileges } from 'src/app/core/privileges/privileges';

export enum RiskAssessmentValueType {
  Hazard = 'Hazards',
  Consequence = 'Consequences',
  MitigatingMeasure = 'MitigatingMeasures',
  OperationType = 'OperationTypes',
  Location = 'Locations',
}

export const RISK_ASSESSMENT_VALUE_TITLES: any = {
  [RiskAssessmentValueType.Hazard]: 'hazards',
  [RiskAssessmentValueType.Consequence]: 'consequences',
  [RiskAssessmentValueType.MitigatingMeasure]: 'mitigatingMeasures',
  [RiskAssessmentValueType.OperationType]: 'operationTypes',
  [RiskAssessmentValueType.Location]: 'locations',
};

export const RISK_ASSESSMENT_VALUE_CREATE_TITLE: any = {
  [RiskAssessmentValueType.Hazard]: 'newHazard',
  [RiskAssessmentValueType.Consequence]: 'newConsequence',
  [RiskAssessmentValueType.MitigatingMeasure]: 'newMitigatingMeasure',
  [RiskAssessmentValueType.OperationType]: 'newOperationType',
  [RiskAssessmentValueType.Location]: 'newLocation',
};

export const RISK_ASSESSMENT_VALUE_UPDATE_TITLE: any = {
  [RiskAssessmentValueType.Hazard]: 'updateHazard',
  [RiskAssessmentValueType.Consequence]: 'updateConsequence',
  [RiskAssessmentValueType.MitigatingMeasure]: 'updateMitigatingMeasure',
  [RiskAssessmentValueType.OperationType]: 'updateOperationType',
  [RiskAssessmentValueType.Location]: 'updateLocation',
};

export const RISK_ASSESSMENT_VALUE_CREATED_MESSAGE: any = {
  [RiskAssessmentValueType.Hazard]: 'hazardCreated',
  [RiskAssessmentValueType.Consequence]: 'consequenceCreated',
  [RiskAssessmentValueType.MitigatingMeasure]: 'mitigatingMeasureCreated',
  [RiskAssessmentValueType.OperationType]: 'operationTypeCreated',
  [RiskAssessmentValueType.Location]: 'locationCreated',
};

export const RISK_ASSESSMENT_VALUE_UPDATED_MESSAGE: any = {
  [RiskAssessmentValueType.Hazard]: 'hazardUpdated',
  [RiskAssessmentValueType.Consequence]: 'consequenceUpdated',
  [RiskAssessmentValueType.MitigatingMeasure]: 'mitigatingMeasureUpdated',
  [RiskAssessmentValueType.OperationType]: 'operationTypeUpdated',
  [RiskAssessmentValueType.Location]: 'locationUpdated',
};

export const RISK_ASSESSMENT_VALUE_DELETED_MESSAGE: any = {
  [RiskAssessmentValueType.Hazard]: 'hazardDeleted',
  [RiskAssessmentValueType.Consequence]: 'consequenceDeleted',
  [RiskAssessmentValueType.MitigatingMeasure]: 'mitigatingMeasureDeleted',
  [RiskAssessmentValueType.OperationType]: 'operationTypeDeleted',
  [RiskAssessmentValueType.Location]: 'locationDeleted',
};

export const RISK_ASSESSMENT_VALUE_TABLE_FILTERS: any = {
  [RiskAssessmentValueType.Hazard]: MainTableFilterModulesEnum.Hazards,
  [RiskAssessmentValueType.Consequence]: MainTableFilterModulesEnum.Consequences,
  [RiskAssessmentValueType.MitigatingMeasure]: MainTableFilterModulesEnum.MitigatingMeasures,
  [RiskAssessmentValueType.OperationType]: MainTableFilterModulesEnum.OperationTypes,
  [RiskAssessmentValueType.Location]: MainTableFilterModulesEnum.Locations,
};

export const RISK_ASSESSMENT_VALUE_CREATE_PRIVILEGE: any = {
  [RiskAssessmentValueType.Hazard]: Privileges.RiskAssessmentHazardCreate,
  [RiskAssessmentValueType.Consequence]: Privileges.RiskAssessmentConsequenceCreate,
  [RiskAssessmentValueType.MitigatingMeasure]: Privileges.RiskAssessmentMitigatingMeasuresCreate,
  [RiskAssessmentValueType.OperationType]: Privileges.RiskAssessmentOperationTypeCreate,
  [RiskAssessmentValueType.Location]: Privileges.RiskAssessmentLocationCreate,
};

export const RISK_ASSESSMENT_VALUE_UPDATE_PRIVILEGE: any = {
  [RiskAssessmentValueType.Hazard]: Privileges.RiskAssessmentHazardUpdate,
  [RiskAssessmentValueType.Consequence]: Privileges.RiskAssessmentConsequenceUpdate,
  [RiskAssessmentValueType.MitigatingMeasure]: Privileges.RiskAssessmentMitigatingMeasuresUpdate,
  [RiskAssessmentValueType.OperationType]: Privileges.RiskAssessmentOperationTypeUpdate,
  [RiskAssessmentValueType.Location]: Privileges.RiskAssessmentLocationUpdate,
};

export const RISK_ASSESSMENT_VALUE_DELETE_PRIVILEGE: any = {
  [RiskAssessmentValueType.Hazard]: Privileges.RiskAssessmentHazardDelete,
  [RiskAssessmentValueType.Consequence]: Privileges.RiskAssessmentConsequenceDelete,
  [RiskAssessmentValueType.MitigatingMeasure]: Privileges.RiskAssessmentMitigatingMeasuresDelete,
  [RiskAssessmentValueType.OperationType]: Privileges.RiskAssessmentOperationTypeDelete,
  [RiskAssessmentValueType.Location]: Privileges.RiskAssessmentLocationDelete,
};
